import React from 'react';

import { FooterSubcomponentProps } from '.';
import { css } from '@emotion/react';
import { Grid, Link, Typography } from '@mui/material';
import { Theme, useTheme } from '@mui/material/styles';

import ContactInfoComponent from './ContactInfoSection';
import { getKeyFromLinkSection } from './utils';

const DesktopFooter: React.FC<FooterSubcomponentProps> = ({
  linkSections,
  contactInfoSection,
  watermark,
  watermarkColor,
  textColor,
  accentTextColor,
  isShowingCart,
}) => {
  const theme = useTheme();
  const generateStyles = (theme: Theme) =>
    css({
      maxWidth: theme.breakpoints.values.contentMaxWidth,
      padding: '0 1rem',
      margin: 'auto',
      marginBottom: isShowingCart ? '2.5rem' : undefined,
      ['.links-section']: {
        paddingTop: '2rem',
      },
      ['.watermark']: {
        padding: '2rem 0',
      },
    });
  const styles = generateStyles(theme);

  return (
    <Grid container direction="column" css={styles}>
      <Grid>
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          className="links-section"
        >
          {linkSections.map((linkSection, idx) => {
            const { header, links } = linkSection;
            return (
              <Grid key={getKeyFromLinkSection(linkSection, idx)}>
                <Grid container direction="column" alignItems="baseline">
                  {header && (
                    <Typography variant="h6" color={accentTextColor}>
                      {header}
                    </Typography>
                  )}
                  {links?.map((link) => (
                    <Grid
                      key={`${link.url}-${link.displayText}`}
                      css={{
                        padding: '0.25rem 0',
                      }}
                    >
                      <Link
                        href={link.url}
                        underline="hover"
                        target={link.target}
                      >
                        <Typography variant="caption" color={textColor}>
                          {link.displayText}
                        </Typography>
                      </Link>
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            );
          })}
          <Grid>
            <ContactInfoComponent {...contactInfoSection} />
          </Grid>
        </Grid>
      </Grid>
      <Grid>
        <Typography
          className="watermark"
          color={watermarkColor}
          variant="body2"
        >
          {watermark}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default DesktopFooter;
